import { render, staticRenderFns } from "./SnowButton.vue?vue&type=template&id=5708957a&scoped=true&"
import script from "./SnowButton.vue?vue&type=script&lang=js&"
export * from "./SnowButton.vue?vue&type=script&lang=js&"
import style0 from "./SnowButton.vue?vue&type=style&index=0&id=5708957a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5708957a",
  null
  
)

export default component.exports